import { language } from "language/default";
export var UserPreferencesUnitOfAreaEnum;
(function (UserPreferencesUnitOfAreaEnum) {
    UserPreferencesUnitOfAreaEnum["SquareMeter"] = "squareMeter";
    UserPreferencesUnitOfAreaEnum["SquareFoot"] = "squareFoot";
    UserPreferencesUnitOfAreaEnum["Acre"] = "acre";
    UserPreferencesUnitOfAreaEnum["Hectare"] = "hectare";
})(UserPreferencesUnitOfAreaEnum || (UserPreferencesUnitOfAreaEnum = {}));
const unitOfAreaName = language.en.modal.settings.unitOfAreaSettings.units;
export const unitOfAreas = {
    [UserPreferencesUnitOfAreaEnum.SquareMeter]: {
        name: unitOfAreaName.squareMeter
    },
    [UserPreferencesUnitOfAreaEnum.SquareFoot]: {
        name: unitOfAreaName.squareFoot
    },
    [UserPreferencesUnitOfAreaEnum.Acre]: {
        name: unitOfAreaName.acre
    },
    [UserPreferencesUnitOfAreaEnum.Hectare]: {
        name: unitOfAreaName.hectare
    }
};
